module.exports = __webpack_public_path__ + "static/media/arrow-circle-left.db56b7e5.svg";